import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import DropdownButton from 'chameleon/ui-stack/ui/buttons/dropdown-button';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import { buttonClassName, iconProps } from './constants';

const AssignButton = forwardRef(({ isDropdownButton, onClick }, ref) => {
  if (isDropdownButton) {
    return (
      <DropdownButton
        ref={ref}
        onClick={onClick}
        className={buttonClassName}
        {...iconProps}
      >
        Assign
      </DropdownButton>
    );
  }

  return (
    <ButtonWithIcon
      ref={ref}
      className={buttonClassName}
      {...iconProps}
      accessibility={{ 'aria-label': 'Assign all' }}
      onClick={onClick}
    >
      Assign All
    </ButtonWithIcon>
  );
});

AssignButton.propTypes = {
  isDropdownButton: PropTypes.bool,
  onClick: PropTypes.func,
};

AssignButton.defaultProps = {
  isDropdownButton: false,
  onClick: () => {},
};

export default AssignButton;
